var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9151_63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87.5,
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9151_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.923 44H129.557L97.5949 80.8492L135.193 131H105.762L82.6949 100.591L56.3287 131H41.6711L75.8509 91.5763L39.8071 44H69.9847L90.8145 71.7943L114.923 44ZM109.784 122.174H117.888L65.5692 52.3652H56.8652L109.784 122.174Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9151_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9151_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white",
    transform: "translate(44 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.31833b7de1570265dcccb07046b9ea1e.svg";
export { ForwardRef as ReactComponent };